// src/config/external-urls.ts
// External static links — single source of truth on the React side. Mirrors the Flutter
// scrips_core app_constants.dart (privacyPolicy / termsAndCondition). If these paths
// change, update them here (one place), not in components.
export const LEGAL_URLS = {
  privacyPolicy: 'https://scrips.com/legal/privacy',
  termsOfUse: 'https://scrips.com/legal/terms-user',
} as const;
